/**
 * Export-module types — gedeelde DTOs + slugs.
 *
 * Zie `docs/specs/ronde-3/05-export-module.md` voor de volledige spec.
 */

// ─── Slug-union ──────────────────────────────────────────────────────────────

export const EXPORT_SLUGS = [
  'verlof-medewerker',
  'verlof-klant',
  'facturen-relatie',
  'facturen-bv',
  'werkuren-medewerker',
  'werkuren-relatie',
  'planning-klant',
  'vakantieplanning',
  'vakantieplanning-klant',
  // Batch-7 fixes fx.1 — drie nieuwe registry-definities.
  'bestuurders-voertuigen',
  'certificaten-medewerkers',
  'profielschetsen',
  // Batch-9 facturen #27/#88 — inkoop-overzichten/betaallijsten.
  'inkoop-betaallijst',
  'inkoop-openstaand',
  'inkoop-per-crediteur',
  // Batch-9 facturen #87 — bulk-download van verkoopfactuur-PDF's (ZIP).
  'facturen-pdf-bulk',
  // Batch-14 FO-015 — inspecties/controlelijsten: CSV-data + PDF-batch (ZIP).
  'inspecties-csv',
  'inspecties-pdf-bulk',
  // Batch-20 FO-078 — BTW-overzicht/aangifte-hulp (per tarief + per BV).
  'btw-overzicht',
  // Batch-20 FO-065 — cursus- en opleidingsdagen (dagen + deelnemers).
  'opleidingsdagen',
  // Batch-20 FO-086 — HR-dossieroverzicht (AVG-inzage), rechten-geredigeerd.
  'dossier',
  // FO-096 (batch-21) — verantwoordelijkheden-overzicht (gebied × verantwoordelijke).
  'verantwoordelijkheden',
  // FO-092 (batch-23) — relatie-lijst (klant-velden + klant-tarieven, GEEN kostprijs/marge).
  'relatie-lijst',
  // FO-320 (batch-36) — voertuigkosten per kenteken/soort/periode (intern, kosten-gate).
  'voertuigkosten',
  // FO-324 P1 (batch-36) — acquisitie-leads (leadpool met filters) + CRM-contactmomenten.
  'acquisitie-leads',
  'crm-contactmomenten',
  // FO-324 P2 (batch-36) — weekstaat-cumulatieven (uren per medewerker over een vrij bereik).
  'uren-cumulatief',
  // FO-322 (batch-36) — AVG-toestemmingen-register (verantwoording).
  'toestemmingen-register',
  // FO-336 (batch-39) — accountant-export declaraties: ZIP met Overzicht.xlsx + bonbestanden.
  'declaraties-accountant',
  // batch-42 onboarding (FO-370) — aanmeldpakket-bulk (ZIP met submap per medewerker).
  'aanmeldpakket-bulk',
  // FO-404 (batch-50 accountant-rol) — accountant-bundel verkoopfacturen:
  // ZIP met de factuur-PDFs van de GEFILTERDE set (alleen definitief/verzonden).
  'facturen-accountant',
  // FO-404 (batch-50 accountant-rol) — accountant-bundel inkoopfacturen:
  // Overzicht.xlsx (incl. kostentoewijzing) + de originele factuurdocumenten.
  'inkoop-accountant',
  // FO-455 (batch-61 uitrusting-credits-maten) — kledingmaten per medewerker
  // (boven/broek/schoen/handschoen/helm + pasvorm-opmerking + laatst gewijzigd).
  'maten-medewerkers',
  // batch-65 inkoop-kosten (FO-482 T7) — inkoopregels met code, hoofdgroep,
  // kostensoort en grootboekrekening (accountant/boekhouding).
  'inkoop-kostensoorten',
  // batch-65 inkoop-kosten (FO-483 §7) — omzet, toegerekende inkoop, doorbelast
  // en marge per klant over een periode (alleen met margerecht).
  'klant-kosten-marge',
  // batch-65 voorraad-besteladvies (FO-481 §F) — historie van de besteladviezen
  // (adviesregels, beoordeling, automatische order, levering, minimumvoorstel).
  'besteladviezen',
  // batch-68 controle (FO-342 §3.11) — verloningscontrole van één urenmaand
  // (medewerkers + samenvatting, per klant, per week, saldi, bevindingen).
  'verloningscontrole',
  // batch-68 materieel-exports (FO-340) — materieel-, voorraad- en vlootexports.
  'gereedschap-set-inhoud',
  'gereedschap-set-exemplaren',
  'voorraad-compleet',
  'voorraad-artikel',
  'voertuigen',
  'bestuurders',
  'tankpassen',
  'gereedschap-catalogus',
  'apparatuur',
  'uitgegeven-middelen',
  'gereedschap-aanvragen',
  'materieel-abonnementen',
  'voertuig-meldingen',
  // batch-69 km-balans (FO-515 §C7) — werk- en privé-indicatie per medewerker per maand
  // plus de factor en bron per voertuig (kostprijsrecht).
  'kilometerbalans',
  // batch-69 planbord-afspraak (FO-523) — afspraken met klanten (CRM-rapportage).
  'crm-afspraken',
  // batch-69 vakantiecampagne (FO-519 §C6) — het controle-overzicht van een
  // vakantiecampagne (periodes per medewerker, week en klant).
  'vakantiecampagne',
  // batch-69 actiepunten (FO-514) - het register "Actiepunten app" met alle kolommen.
  'actiepunten',
  // batch-69 tvt-saldi (FO-513 §B5) — opbouwkeuzes TVT/ATV per periode, uitkomst
  // per week/dag met de dubbel-indicator, wijzigingshistorie.
  'opbouwkeuzes-tvt-atv',
  // batch-69 magazijn-cijfers (FO-521 §A) — voorraadwaarde per onderdeel en
  // locatie (bulk, uniek, totalen, zonder prijs, niveaus); alleen met kostprijsrecht.
  'voorraad-waarde',
  // batch-69 magazijn-cijfers (FO-520 §C14) — tellijst en telrapport van één
  // telsessie (alleen vanuit de telling; automatisch in de bibliotheek bij afronden).
  'voorraad-telrapport',
  // batch-70 uitrusting-controle (FO-531 §7) — wat ontbreekt, defect is of niet
  // ontvangen (per onderdeel en per medewerker, plus de uitgiftelijst en de
  // keuringen; ook het eindrapport bij het sluiten) en de stand van de
  // bruikleenovereenkomsten per medewerker. Alleen vanuit de campagne.
  'uitrustingscontrole-ontbrekend',
  'uitrustingscontrole-overeenkomsten',
  // batch-70 voertuig-meldingen (FO-527 §7) — de melding-opdrachten per kanaal
  // (Wassink, Cartracker, NAW) met status en bevestiging. Bewust niet
  // `voertuig-meldingen`: die slug is van de bestuurdersmeldingen (FO-340).
  'voertuig-mutatie-meldingen',
  // batch-70 wagenpark-week (FO-528 + FO-529) - het weekrapport (km en tankpas, ook als
  // bijlage via exportNaarBuffer), de km-trend en de afwijkingen uren en ritten.
  'voertuig-km-weekrapport',
  'voertuig-km-trend',
  'rit-uren-afwijkingen',
  'tankpas-weekrapport',
  // batch-70 app-dashboard (FO-526) - Systeem > App dashboard: de wijzigingen per FO
  // met plek, status, livegang (met de schattingen) en de open actiepunten.
  'app-wijzigingen',
  // batch-71 workflow-sjablonen (FO-533 §7) - de stappenplannen (OPERATIONELE_TAKEN.canView).
  'workflow-runs',
  // batch-71 gesprek-secties (FO-536 §3.B, FO-537 §3.B) - de twee HRM-overzichten.
  'ontwikkeldoelen',
  'gesprekscontroles',
  // batch-71 kennismaking (FO-534 §7) - HRM > Onboarding > Kennismakingen.
  'onboarding-kennismakingen',
  // batch-71 verplichte-certificaten (FO-541 §C6) - per medewerker per verplichte eis, uit de stand.
  'verplichte-certificaten',
] as const

export type ExportSlug = (typeof EXPORT_SLUGS)[number]

// ─── Branding ────────────────────────────────────────────────────────────────

/**
 * Branding-mode. Voor `klant`-branded exports geldt: GEEN tarieven, kosten of
 * interne opmerkingen — dit wordt op typescript-niveau afgedwongen door de
 * `ExportDefinition.branding === 'klant'` exports een strict whitelist te geven
 * via {@link ClientSafeColumnKey}.
 */
export type ExportBranding = 'streep' | 'klant'

// ─── FO-340 (batch-68) — UI-metadata per export ─────────────────────────────
//
// Het centrale exportscherm (`/exports`) bouwt zijn filterformulier uit de
// definitie: groep, datumrange-gedrag, filtervelden en bestandstype komen mee in
// `GET /exports`. Vóór FO-340 stonden die per slug hardcoded in de client
// (`DATUMRANGE_VRIJ`, `needsClientId`, `allowsEntityFilter`, ...): elke nieuwe
// export moest de client aanraken en de lijst liep uit de pas met de API.

export const EXPORT_GROEPEN = [
  'verlof-planning',
  'uren',
  'facturatie',
  'inkoop',
  'hr',
  'crm',
  'kwaliteit',
  'organisatie',
  'materieel',
  'overig',
] as const
export type ExportGroep = (typeof EXPORT_GROEPEN)[number]

export const EXPORT_GROEP_LABELS: Record<ExportGroep, string> = {
  'verlof-planning': 'Verlof en planning',
  uren: 'Uren',
  facturatie: 'Facturatie',
  inkoop: 'Inkoop en declaraties',
  hr: 'HR',
  crm: 'Relaties en acquisitie',
  kwaliteit: 'Kwaliteit',
  organisatie: 'Organisatie',
  materieel: 'Materieel en voorraad',
  overig: 'Overig',
}

/**
 * Datumrange-gedrag van een export: `verplicht` (van + t/m altijd mee, het
 * gedrag van vóór FO-340), `optioneel` (velden zichtbaar maar mogen leeg) of
 * `geen` (peildatum- of selectie-gebaseerd, geen range-velden).
 */
export type ExportDatumrange = 'verplicht' | 'optioneel' | 'geen'

/** Bestandstype dat de export oplevert (bepaalt o.a. de knoptekst). */
export type ExportBestandsType = 'xlsx' | 'zip' | 'csv'

/** Eén optie van een keuzeveld (`waarde` = wat in de filter-body komt). */
export interface ExportFilterOptieDTO {
  waarde: string
  label: string
}

/**
 * Toon dit veld alleen wanneer een ander filterveld een bepaalde waarde heeft
 * (bv. de medewerker bij vakantieplanning alleen in modus "per medewerker").
 */
export interface ExportFilterAfhankelijkheidDTO {
  sleutel: string
  waarde: string
}

interface ExportFilterVeldBasis {
  /** Sleutel in de filter-body (bv. `employeeId`, `entityId`). */
  sleutel: string
  /** Label boven het veld (NL). */
  label: string
  /** Verplicht veld: de downloadknop blijft uit tot het gevuld is. */
  verplicht?: boolean
  alleenBij?: ExportFilterAfhankelijkheidDTO
}

/**
 * Eén filterveld in het centrale exportscherm. `soort` bepaalt de component
 * (zoekbare picker, keuzelijst, vinkje, datum). De API valideert de body altijd
 * zelf (Zod); deze beschrijving is alleen de vorm van het formulier.
 */
export type ExportFilterVeldDTO =
  | (ExportFilterVeldBasis & { soort: 'medewerker' })
  | (ExportFilterVeldBasis & {
      soort: 'medewerkers'
      /** Filtersleutel van een BV-veld dat de medewerkerlijst scopet. */
      bvSleutel?: string
    })
  | (ExportFilterVeldBasis & {
      soort: 'klant'
      /** Toon ook het vrije veld "Klantnaam (branding)" (legacy klant-exports). */
      brandingNaam?: boolean
    })
  | (ExportFilterVeldBasis & { soort: 'bv' })
  | (ExportFilterVeldBasis & { soort: 'afdeling' })
  | (ExportFilterVeldBasis & { soort: 'voertuig' })
  | (ExportFilterVeldBasis & { soort: 'leverancier' })
  | (ExportFilterVeldBasis & { soort: 'locatie' })
  | (ExportFilterVeldBasis & { soort: 'artikelen'; max: number })
  | (ExportFilterVeldBasis & { soort: 'pakketten' })
  | (ExportFilterVeldBasis & { soort: 'templates' })
  | (ExportFilterVeldBasis & { soort: 'dragers' })
  | (ExportFilterVeldBasis & { soort: 'module-onderdeel' })
  | (ExportFilterVeldBasis & { soort: 'certificaattype' })
  | (ExportFilterVeldBasis & { soort: 'modus' })
  | (ExportFilterVeldBasis & {
      /** Een kalenderdatum (yyyy-mm-dd); leeg = vandaag (niet meegestuurd). */
      soort: 'peildatum'
      /** Datums in de toekomst toestaan (default: nee). */
      toekomstToegestaan?: boolean
    })
  | (ExportFilterVeldBasis & {
      soort: 'keuze'
      opties: ExportFilterOptieDTO[]
      /** Beginwaarde; zonder = de eerste optie of leeg (`leegLabel`). */
      standaard?: string
      /** Label van de lege keuze ("Alle"); zonder = geen lege keuze. */
      leegLabel?: string
      /** `boolean`: de gekozen waarde gaat als true/false mee. */
      waardeType?: 'tekst' | 'boolean'
      /** Deze waarde betekent "geen filter" en wordt niet meegestuurd. */
      weglatenBij?: string
    })
  | (ExportFilterVeldBasis & {
      /**
       * batch-69 magazijn-cijfers — meervoudige keuze uit een vaste lijst (zoekbaar,
       * met chips). De gekozen waarden gaan als array mee; leeg = geen filter.
       * `afhankelijkVan`: de opties worden beperkt tot die met een `groep` die
       * in dat (meerkeuze-)veld gekozen is (bv. categorie binnen hoofdgroep).
       */
      soort: 'meerkeuze'
      opties: Array<ExportFilterOptieDTO & { groep?: string }>
      placeholder?: string
      afhankelijkVan?: string
    })
  | (ExportFilterVeldBasis & { soort: 'vinkje'; standaard: boolean })
  | (ExportFilterVeldBasis & { soort: 'tekst'; placeholder?: string })

/** Soorten filtervelden (handig voor exhaustieve switches in de UI). */
export type ExportFilterVeldSoort = ExportFilterVeldDTO['soort']

/**
 * Vanaf dit aantal regels meldt de UI dat de export even kan duren (FO-340 §5).
 * Er is geen harde limiet: grote exports streamen.
 */
export const EXPORT_GROOT_DREMPEL = 50_000

/** Maximaal aantal artikelen in één `voorraad-artikel`-export (FO-340 §6). */
export const VOORRAAD_ARTIKEL_EXPORT_MAX = 100

/**
 * Maximale lengte van een exportperiode in dagen (1 jaar, incl. een
 * schrikkeldag). Eén waarde voor de engine, de definities en de dialogen.
 */
export const EXPORT_MAX_PERIODE_DAGEN = 366

// ─── Beschikbare exports ─────────────────────────────────────────────────────

/**
 * Lijst-item zoals teruggegeven door `GET /exports`. Alleen exports waar de
 * huidige user toegang toe heeft staan in `availableTypes`.
 */
export interface ExportListItemDTO {
  slug: ExportSlug
  label: string
  description: string
  branding: ExportBranding
  /** Modus-modes alleen voor `vakantieplanning`; andere exports laten dit leeg. */
  modes?: Array<{ value: string; label: string }>
  /** FO-340 — groep in het exportscherm (default `overig`). */
  groep: ExportGroep
  /** FO-340 — datumrange-gedrag (default `verplicht` = gedrag van vóór FO-340). */
  datumrange: ExportDatumrange
  /** FO-340 — bij `optioneel`: de periode vooraf invullen met de afgelopen maand. */
  periodeVooringevuld: boolean
  /** FO-340 — alleen vanuit de eigen lijst te draaien (niet op het exportscherm). */
  alleenVanuitLijst: boolean
  /** FO-340 — filtervelden naast de datumrange, in weergavevolgorde. */
  filterVelden: ExportFilterVeldDTO[]
  /** FO-340 — minstens één van deze filtersleutels moet gevuld zijn. */
  vereistEenVan: string[]
  /** FO-340 — bestandstype van de download. */
  bestandsType: ExportBestandsType
  /** FO-340 — de API kan vooraf het aantal regels tellen (`POST /exports/:slug/telling`). */
  heeftTelling: boolean
}

/** FO-340 — antwoord van `POST /exports/:slug/telling`. */
export interface ExportTellingDTO {
  /** Aantal hoofdregels dat de export met deze filters oplevert. */
  aantal: number
}

export interface ExportListResponseDTO {
  availableTypes: ExportListItemDTO[]
}

// ─── Gedeelde filters ────────────────────────────────────────────────────────

/**
 * Iedere export deelt deze datumrange-filters. Validatie (1-jaar max) zit in
 * de engine; de Zod-schema's van de individuele exports parsen alleen het
 * input-formaat (yyyy-mm-dd).
 */
export interface ExportBaseFilters {
  van: string
  totEnMet: string
}

// ─── Vakantieplanning-modus ──────────────────────────────────────────────────
//
// LET OP: De aparte slug `vakantieplanning-klant` heeft géén modus — die is
// een dedicated klant-branded export met een vaste whitelist van velden.
// Onderstaande modus geldt alleen voor de interne (streep) `vakantieplanning`.

export type VakantieplanningModus = 'medewerker' | 'totaal'

// ─── Forbidden-keys voor klant-branded exports ───────────────────────────────

/**
 * String-literal keys die NOOIT in een klant-branded export mogen voorkomen.
 * Wordt door de `ClientSafeColumnKey` mapped-type gebruikt om kolom-keys op
 * compile-time te valideren.
 */
export type InternalOnlyColumnKey =
  // Tarieven (uurtarieven, etc.) — alleen intern
  | 'uurtarief'
  | 'overuurtarief'
  | 'tarief'
  | 'tarieven'
  | 'unitPrice'
  // Kosten — alleen intern
  | 'kosten'
  | 'kost'
  | 'totaalKosten'
  | 'marge'
  // Interne opmerkingen
  | 'interneOpmerking'
  | 'interneOpmerkingen'
  | 'internalNotes'
  | 'opmerkingen'
  // Factuur-bedragen — klant ziet eigen factuur, niet onze interne berekening
  | 'invoiceAmount'
  | 'subtotal'
  | 'vatAmount'
  | 'factuurSubtotaal'
  | 'factuurBtw'
  | 'factuurTotaal'
  | 'factuurBedrag'
  | 'reisVergoeding'
  // FO-411 (batch-54) — de netto uitbetaalde km-vergoeding is een LOON-/onkosten-
  // gegeven van de medewerker en gaat nooit naar een klant-export.
  | 'kmVergoedingNetto'
  // Reis-administratieve velden — klant betaalt forfait, niet onze details
  | 'reisKm'
  | 'reisMinuten'
  // Privacy-gevoelig HR-veld — nooit naar buiten
  | 'bsn'
  | 'iban'
  | 'salaris'
  | 'loon'
  | 'bruto'
  | 'netto'

/**
 * Helper: keys die voor klant-branded exports zijn toegestaan. Een kolom-key
 * `K extends ClientSafeColumnKey<R>` mag GEEN literal uit `InternalOnlyColumnKey`
 * matchen. Wordt door de engine afgedwongen.
 */
export type ClientSafeColumnKey<K> = K extends InternalOnlyColumnKey ? never : K

// ─── FO-116-B (batch-22) — eigen exports in de medewerker-app ─────────────────
//
// Read-only inzage in de exports die de ingelogde gebruiker zélf draaide
// (`Document` scope=EXPORT, uploadedBy = eigen userId). Server-side hard gescoped;
// de monteur ziet nooit andermans of bedrijfsbrede exports. Download loopt via
// het eigen, scope-gegate portal-endpoint (niet de backoffice-bibliotheek).
export interface MijnExportDTO {
  /** Document-id. */
  id: string
  titel: string
  /** Export-slug (bv. 'opleidingsdagen'); null voor handmatige exports. */
  exportType: string | null
  /** ISO-timestamp van aanmaak (UTC; UI toont Europe/Amsterdam). */
  exportDatum: string
  /** Bestandsnaam van de laatste versie, of null. */
  bestandsnaam: string | null
  /** Versienummer voor de download-link, of null als er geen versie is. */
  versieNr: number | null
}
